module.exports = __webpack_public_path__ + "static/media/Icn-doc.dd19eff5.svg";